/* Belilan — Amazon-style per-variant swap: title, description, image gallery.
   Data source: variant metafields custom.vswap rendered as JSON by snippets/bl-vswap.liquid.
   Hooks Minimog's document 'variant:changed' event. Frontend-only; product data untouched. */
(function () {
  var dataEl = document.querySelector('script[data-bl-vswap]');
  if (!dataEl) return;

  var PAYLOAD;
  try { PAYLOAD = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var MAP = PAYLOAD.variants || {};
  var VIDS = PAYLOAD.vids || [];
  var LOCALE = (dataEl.getAttribute('data-locale') || 'en').toLowerCase() === 'fr' ? 'fr' : 'en';

  var section = dataEl.closest('.m-main-product') || document.querySelector('.m-main-product');
  if (!section) return;
  var titleEl = section.querySelector('.m-product-title');
  var descEl = section.querySelector('.m-product-description');
  var base = {
    title: titleEl ? titleEl.textContent : '',
    desc: descEl ? descEl.innerHTML : ''
  };

  var style = document.createElement('style');
  style.textContent =
    '.m-main-product .m-media-gallery{position:relative;}' +
    '.bl-vs{position:absolute;inset:0;z-index:5;display:none;flex-direction:column;}' +
    '.bl-vs.is-on{display:flex;}' +
    '.bl-vs__main{flex:1 1 auto;min-height:0;display:flex;align-items:center;justify-content:center;}' +
    '.bl-vs__main img{aspect-ratio:1/1;width:auto;height:auto;max-width:100%;max-height:100%;object-fit:contain;background:#fff;}' +
    '.bl-vs__thumbs{flex:0 0 auto;display:flex;gap:8px;padding:10px 4px 2px;overflow-x:auto;justify-content:center;}' +
    '.bl-vs__thumb{width:56px;height:56px;flex:0 0 auto;border:1px solid #d5d9d9;border-radius:6px;background:#fff;padding:2px;cursor:pointer;transition:border-color .15s ease;}' +
    '.bl-vs__thumb img{width:100%;height:100%;object-fit:contain;display:block;}' +
    '.bl-vs__thumb.is-active{border-color:var(--color-primary,#146e73);box-shadow:0 0 0 1px var(--color-primary,#146e73);}';
  document.head.appendChild(style);

  var overlays = [];
  function ensureOverlays() {
    if (overlays.length) return overlays;
    var galleries = section.querySelectorAll('.m-media-gallery');
    for (var i = 0; i < galleries.length; i++) {
      var g = galleries[i];
      var el = document.createElement('div');
      el.className = 'bl-vs';
      var bg = getComputedStyle(g).backgroundColor;
      if (!bg || bg === 'rgba(0, 0, 0, 0)') {
        bg = getComputedStyle(document.body).backgroundColor || '#fff';
      }
      el.style.background = bg;
      el.innerHTML = '<div class="bl-vs__main"><img alt=""></div><div class="bl-vs__thumbs"></div>';
      g.appendChild(el);
      overlays.push(el);
    }
    return overlays;
  }

  function showImages(imgs) {
    var ovs = ensureOverlays();
    for (var i = 0; i < ovs.length; i++) {
      (function (ov) {
        var main = ov.querySelector('.bl-vs__main img');
        var strip = ov.querySelector('.bl-vs__thumbs');
        main.src = imgs[0];
        strip.innerHTML = '';
        if (imgs.length > 1) {
          for (var k = 0; k < imgs.length; k++) {
            (function (url, idx) {
              var b = document.createElement('button');
              b.type = 'button';
              b.className = 'bl-vs__thumb' + (idx === 0 ? ' is-active' : '');
              b.setAttribute('aria-label', 'Image ' + (idx + 1));
              var im = document.createElement('img');
              im.src = url;
              im.alt = '';
              im.loading = 'lazy';
              b.appendChild(im);
              b.addEventListener('click', function () {
                main.src = url;
                var act = strip.querySelector('.is-active');
                if (act) act.classList.remove('is-active');
                b.classList.add('is-active');
              });
              strip.appendChild(b);
            })(imgs[k], k);
          }
        }
        ov.classList.add('is-on');
      })(ovs[i]);
    }
  }

  function hideOverlays() {
    for (var i = 0; i < overlays.length; i++) overlays[i].classList.remove('is-on');
  }

  function pick(d, key) {
    return d && typeof d[key] === 'string' && d[key] ? d[key] : null;
  }

  function apply(variantId) {
    var d = variantId != null ? MAP[String(variantId)] : null;
    if (titleEl) {
      var t = d ? (pick(d, 't_' + LOCALE) || pick(d, 't_en')) : null;
      titleEl.textContent = t || base.title;
    }
    if (descEl) {
      var dd = d ? (pick(d, 'd_' + LOCALE) || pick(d, 'd_en')) : null;
      descEl.innerHTML = dd || base.desc;
    }
    var imgs = d && d.imgs && d.imgs.length ? d.imgs : null;
    if (imgs) showImages(imgs); else hideOverlays();
  }

  function currentVariantId() {
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    if (m) return m[1];
    var sel = section.querySelector('variant-picker [data-selected-variant]');
    if (sel) {
      try {
        var v = JSON.parse(sel.textContent);
        if (v && v.id) return v.id;
      } catch (e) { /* fall through */ }
    }
    var input = section.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input && input.value ? input.value : null;
  }

  document.addEventListener('variant:changed', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v || !v.id) return;
    if (VIDS.length && VIDS.indexOf(Number(v.id)) === -1) return; /* quick-view of another product */
    apply(v.id);
  });

  apply(currentVariantId());
})();
